module.exports = __webpack_public_path__ + "img/banner_2.9d7fc167.jpg";